import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

const paddings = {
    desktop: 256,
    sDesktop: 161,
    laptop: 140,
    tablet: 96,
};

const dividedKoef = 6;

const getBg = (src: string, padding: number) => `linear-gradient(to right, transparent ${padding / dividedKoef}px, ${COLORS.BgSurface} ${padding}px), url(${src})`;
const getMBg = (src: string, padding: number) => `linear-gradient(to bottom, transparent ${padding / 2 / dividedKoef}px, ${COLORS.BgSurface} ${padding}px), url(${src})`;

export const CheckAddressConnect = styled.div<{ imgSrc: string}>`
    position: relative;
    flex-direction: column;
    width: 100%;
    margin: 80px 0;
    padding: 32px;
    padding-left: ${paddings.desktop}px;
    border-radius: ${BorderRadius.OuterBlockRadius};
    background-color: ${COLORS.BgSurface};

    background-image: ${p => getBg(p.imgSrc, paddings.desktop)};
    background-repeat: no-repeat;
    background-position: left top;
    background-size: contain;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        background-image: ${p => getBg(p.imgSrc, paddings.sDesktop)};
        padding-left: ${paddings.sDesktop}px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        background-image: ${p => getBg(p.imgSrc, paddings.laptop)};
        padding-left: ${paddings.laptop}px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        padding: ${paddings.tablet}px 16px 24px 16px;
        background-image: ${p => getMBg(p.imgSrc, paddings.tablet)};
        background-position: center top;        
        background-size: 100% auto;
    }
`;

export const Title = styled.div`
    margin-bottom: 8px;
    ${FONTS.H2};

    @media (max-width: ${wideBreakpoints.tablet}) {
        margin-bottom: 4px;
        ${FONTS.H4};
    }
`;

export const Text = styled.div`
    margin-bottom: 16px;
    ${FONTS.S};
    color: ${COLORS.TextInfo};
`;
